
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/selling/professionals",
      function () {
        return require("private-next-pages/selling/professionals.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/selling/professionals"])
      });
    }
  